import * as React from 'react';
import NavBar from 'src/components/NavBar';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import ProfilePicture from './components/ProfilePicture';
import styled from 'styled-components';
import GetStartedFooter from './components/GetStartedFooter';
import Moksh_Headshot from 'src/assets/PersonalImages/Moksh_Headshot.jpg';
import Ash_Headshot from 'src/assets/PersonalImages/Ash_Headshot.jpg';

const AboutUsPageContainer = styled.div`
  width: 100%;
  min-height: calc(100vh - 88px);
`;

const CenteredPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const AboutDetailText = styled.p`
  font-family: Inter UI;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 29px;
  text-align: center;

  color: #333333;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const AboutUsPage = () => {
  return (
    <CenteredPageContainer>
      <NavBar />
      <AboutUsPageContainer>
        <Row style={{ paddingTop: 40, paddingBottom: 70, width: '100%' }}>
          <Col xs={{ offset: 1, size: 5 }} md={{ offset: 3, size: 2 }}>
            <ProfilePicture profImg={Moksh_Headshot} profName="Moksh Jawa" />
          </Col>
          <Col xs={{ offset: 1, size: 5 }} md={{ offset: 2, size: 2 }}>
            <ProfilePicture profImg={Ash_Headshot} profName="Aashish Jain" />
          </Col>
        </Row>
        <Row>
          <Col xs={{ offset: 1, size: 10 }}>
            <AboutDetailText>
              As sophomores at Penn, we used traditional storage last summer and were disappointed
              by the moldy condition our boxes came back in and the expensive prices we had to pay.
              We realized there were so many students living very close to campus who had empty
              basements and rooms that were unused. We developed StoreWith to connect students who
              wanted cheap and reliable storage with students living off-campus who could use that
              income to pay rent.
            </AboutDetailText>
          </Col>
        </Row>
      </AboutUsPageContainer>
      <GetStartedFooter />
    </CenteredPageContainer>
  );
};

export default AboutUsPage;



// WEBPACK FOOTER //
// ./src/pages/AboutUs/AboutUsPage.tsx